import React, { ReactNode } from 'react';

import './CategoryCountLabel.scss';

interface ICategoryCreateCountLabelProps {
  label: ReactNode;
  content: string;
  maxLength: number;
}
const CategoryCountLabel = ({ label, content, maxLength }: ICategoryCreateCountLabelProps): JSX.Element => {
  return (
    <div className="category-common-count-label">
      {label}
      <div className="count-of-total">
        (<span> {content ? content.length : 0} </span>/{maxLength})
      </div>
    </div>
  );
};

export default CategoryCountLabel;
